import styled, { createGlobalStyle, css } from 'styled-components';
export const SuccessMessageStyles = createGlobalStyle `
  ${({ affix, theme: { successMessageWrapper, successMessageButton, }, }) => css `
    #success-wrapper-${affix} {
      ${successMessageWrapper}
      
      .btn {
        ${successMessageButton}
      }
    }
  `}
`;
export const Wrapper = styled.div `
  width: 100%;
  max-width: 74rem;
  margin: 0 auto;
  text-align: center;
  color: white;
  padding: 0 2rem;

  h2 {
    margin-bottom: 0.7rem;
  }

  h3, img {
    margin-bottom: 1.2rem;
  }
`;
